import {
    REFERRAL_LINKS_FETCH,
    REFERRAL_LINKS_IS_FETCING,
    REFERRAL_LINKS_API,
    REFERRAL_LINK_EDIT,
    REFERRAL_LINK_FILTER,
} from 'constants/referralLinks'

//HTTP reuests actions
import {
    put,
    post,
    remove,
    get
} from 'actions/requests'

//Save Propfiles
export const referralLinkSave = (data) => (dispatch, state) => {
    dispatch(referralLinksIsFetching(true))
    return post(REFERRAL_LINKS_API, data)
        .then((e) => { dispatch(referralLinksIsFetching(false)); return e; })
        .catch((e) => { dispatch(referralLinksIsFetching(false)); throw new Error(e) })
}

//Edit Propfiles
export const referralLinkEditSave = (data) => (dispatch, state) => {
    dispatch(referralLinksIsFetching(true))
    return put(REFERRAL_LINKS_API.replace('$profileId', data.profileId), data)
        .then((e) => { dispatch(referralLinksIsFetching(false)); return e; })
        .catch((e) => { dispatch(referralLinksIsFetching(false)); throw new Error(e) })
}



//Feth referralLink by id
export const referralLinkFetch = (id) => (dispatch, state) => {
        dispatch(referralLinksIsFetching(true));
        return get(REFERRAL_LINKS_API + '/' + id)
            .then((e) => { dispatch(referralLinksIsFetching(false)); return e; })
    }
//Feth referralLink by id
export const referralLinkLiteralFetch = (id) => (dispatch, state) => {
        dispatch(referralLinksIsFetching(true));
        return get(REFERRAL_LINKS_API + '/literal/' + id)
            .then((e) => { dispatch(referralLinksIsFetching(false)); return e; })
    }
    //Feth all referralLinks
export const referralLinksFetch = (profileId, ibId) => (dispatch, state) => {
    dispatch(referralLinksIsFetching(true));

    const filter = state().referralLinks.pageable.filter
    let api = Object.keys(filter).reduce((str, el) => str.replace('$' + el, filter[el]), REFERRAL_LINKS_API);
    
    if (api===REFERRAL_LINKS_API) {
        return get(REFERRAL_LINKS_API,{'profileId':profileId,'ibId':ibId})
        .then((e) => {
            dispatch(referralLinksFetched(e))
            return e
        })
        .then((e) => {
            dispatch(
                referralLinkFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .then((e) => { dispatch(referralLinksIsFetching(false)); return e; })
        .finally(e => dispatch(referralLinksIsFetching(false)))
    } else {
        return get(api)
        .then((e) => {
            dispatch(referralLinksFetched(e))
            return e
        })
        .then((e) => {
            dispatch(
                referralLinkFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .then((e) => { dispatch(referralLinksIsFetching(false)); return e; })
        .finally(e => dispatch(referralLinksIsFetching(false)))
    }


}

export const referralLinkAvalableFetch = (data) => (dispatch) => {
	dispatch(referralLinksIsFetching(true))

	return get(REFERRAL_LINKS_API.replace('$profileId', data.profileId) + '/available')
			.then((e) => {
					dispatch(referralLinksFetched(e))
					return e
			})
			.finally(e => dispatch(referralLinksIsFetching(false)))
}

//Remove one referralLink
export const referralLinkRemove = (profileId, ibId) => (dispatch, state) => {
    dispatch(referralLinksIsFetching(true))
    return remove(REFERRAL_LINKS_API.replace('$profileId', profileId) + '/' + ibId)
        .then((e) => {
            dispatch(referralLinksIsFetching(false));
            return e;
        })
}
export const referralLinksFetched = (payload) => ({ type: REFERRAL_LINKS_FETCH, payload: payload })
export const referralLinksIsFetching = (payload) => ({ type: REFERRAL_LINKS_IS_FETCING, payload: payload })
export const referralLinkEdit = (id, data) => ({ type: REFERRAL_LINK_EDIT, payload: data })
export const referralLinkFilter = (data) => ({ type: REFERRAL_LINK_FILTER, payload: data })


// WEBPACK FOOTER //
// ./src/actions/referralLinks.js